<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('utils.itemdetail')}}</div>
		</div>
		<div class="item-main">
			<!-- <div class="item_img"><img :src="data.img"/></div> -->
			<div class="items_3">
				<div class="item">
					<div class="item_div1">
						<!-- <img v-if="data.cover" :src="data.cover" alt="">
						<img v-else src="../../views/images/new/btc.png" alt="">  -->
						<span>{{data.title}}</span>
						<!-- <p>每日可赚100.00</p> -->
					</div>
					<div class="item-body">
						<div class="item_desr">
							<div class="item_desr_left">{{$t('utils.itemdesr')}}</div>
						</div>
						<div class="item_desr">
							<div class="item_desr_left" style="background-color: #ff0000;">{{$t('utils.dailyIncome1')}}{{data.m_name}}{{$t('utils.dailyIncome2')}}</div>
							<div class="item_desr_right"><span>{{$t('utils.dailyIncome')}}:</span> {{data.rate}} %</div>
						</div>
						<div class="item_desr">
							<div class="item_desr_right"><span>{{$t('utils.startingAmount')}}:</span> {{data.min}}</div>
							<div class="item_desr_right"><span>{{$t('utils.endingAmount')}}:</span> {{data.max}}</div>
						</div>
						<div class="item_desr">
							<div class="item_desr_right"><span>{{$t('utils.cycle')}}:</span> {{data.day}} {{$t('utils.day')}}</div>
							<div class="item_desr_right"><span>{{$t('utils.itemnum')}}:</span> {{data.num}} {{$t('utils.itemdanw')}}</div>
						</div>
						<div class="item_desr">
							<div class="item_desr_right"><span>{{$t('utils.scale')}}:</span> {{data.total}}</div>
						</div>
						<div class="item_desr" v-if="data.is_fang==1">
							<div class="item_desr_right"><span>{{$t('utils.pro_fang')}}:</span> {{$t('utils.pro_fang_des')}}</div>
						</div>
					</div>
				</div>
				<div class="item" style="margin-top: 15px;padding-top:15px;">	
					<div class="item-body">
						<div class="item_div4">
							<div class="flex_bd">
								<div class="item-per" style="display: flex;justify-content: space-between;">
									<div>{{$t('utils.scale2')}}</div>
									<div style="text-align: right">{{data.percent}}%</div>
								</div>
								<div class="item-progress">
									<div class="flex_bd"><van-progress track-color="#b8b8b8" color="#eb4718" :percentage="data.percent" /></div>
								</div>
							</div>
							<div class="item_btn">
								<button v-if="data.percent<100" type="button" @click="buy(i)">{{$t('utils.invest')}}</button>
								<button class="item_btn_over" v-if="data.percent>=100" type="button">{{$t('utils.investOver')}}</button>
							</div>
						</div>
					</div>
				</div>
				<div class="item" style="margin-top: 15px;padding-top:15px;">	
					<div class="item-body">
						<div class="item_div4">
							<div class="flex_bd">
								<div class="item-per">
									<span>{{$t('utils.scale3')}}</span>
								</div>
								<div class="item_content" v-html="data.content"></div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="item" style="margin-top: 15px;padding-top:15px;">	
					<div class="item-body">
						<div class="form-cell">
							<div class="flex_bd">
								<input v-model.trim="data.money" type="number" step="0.01" class="inp" :placeholder="$t('invest.rechargeAmount')">
							</div>
							<span class="unit">
								<img src="../images/user/usdt.png" alt="">
								{{$t('utils.moneyMark2')}}
							</span>
						</div>
					</div>
				</div> -->
				
			</div>
		</div>
		<van-dialog
		v-model="show_tz" 
		theme="round-button"
		@confirm="confirm1"
		:confirmButtonText="$t('utils.confirm')"
		>
		<div class="close-x" @click="show_tz = false"><van-icon name="cross" /></div>
		<div class="show-body">
			<div class="sw-cell">
				<div class="sw-label">{{data.title}}</div>
				<div class="sw-bar">
					<div class="flex_bd">
						<van-field v-model="number" type="number" :placeholder="$t('item.inputAmount')" />
					</div>
				</div>
			</div>
			<div class="sw-grid">
				<div class="flex_bd">
					<div class="sw-row">
						<div class="sw-info">{{$t('utils.yuji_sy')}}</div>
						<div class="sw-val">{{(data.rate*data.day*number/100).toFixed(0)}}</div>
					</div>
					<div class="sw-row">
						<div class="sw-val text-green">{{data.rate}}% </div>
						<div class="sw-info">{{$t('utils.cankao_info')}}</div>
					</div>
				</div>
				<div class="sw-right">
					<div class="sw-lg">{{data.day}}{{$t('utils.day')}}</div>
					<div class="sw-info">{{$t('utils.cycle')}}</div>
				</div>
			</div>
			<!-- <div class="sw-end">
				<div class="flex_bd">
					{{$t('utils.tz_auto')}}
				</div>
				<van-switch v-model="checked"  @change="changeAuto" active-color="#ff6034" inactive-color="#dcdee0" size="24px"/>
			</div> -->
		</div>
		<!-- <div class="items_3">
			<div class="item">
				<div class="item_div1">
					<p>
						{{data.title}}
					</p>
				</div>
				<div class="item_div2">
					<div class="item_rate">
						<p>{{data.rate}}%</p>
						<p>{{$t('utils.dailyIncome')}}</p>
					</div>
					<div class="item_day">
						<p>{{data.day}}{{$t('utils.day')}}</p>
						<p>{{$t('utils.cycle')}}</p>
					</div>
					<div class="item_min">
						<p>{{$t('utils.moneyMark')}}{{data.min}}</p>
						<p>{{$t('utils.startingAmount')}}</p>
					</div>
				</div>
			</div>
		</div>
		<van-field v-model="number" type="number" :placeholder="$t('item.inputAmount')"/> -->
		</van-dialog>
		<van-dialog v-model="show_ht" theme="round-button" @confirm="confirm" :confirmButtonText="$t('utils.confirm')"  style="top:50%;">
			
			<div class="show-tc-body">
				<div class="popup" v-html="hetongContent2"></div>
			</div>
			
		</van-dialog>

		<!-- <div class="basic_btn" @click="write_psd = true;submitType = 1;">{{$t('utils.submit')}}</div> -->
		<van-popup v-model="write_psd" round position="bottom">
			<div class="psw_box">
				<div class="psw_content">
					<div class="psw_tips">{{$t('cash.tips')}}</div>
					<van-password-input :value="psd_val" :mask="true" :focused="showKeyboard"
						@focus="showKeyboard = true" />
					<div class="basic_btn psw_complete">{{$t('utils.complete')}}</div>
				</div>
				<div class="keybord_box">
					<div class="keybord">
						<div class="key_item" v-for="i in Keyboard" @click="onInput(i.number)">
							<div class="key_inner">{{i.number}}</div>
							<div class="key_letter">{{i.letter}}</div>
						</div>
						<div class="key_item no_bg" @click="write_psd = false">
							<div class="key_inner">{{$t('utils.cancel')}}</div>
						</div>
						<div class="key_item" @click="onInput(0)">
							<div class="key_inner">0</div>
							<div class="key_letter">abc</div>
						</div>
						<div class="key_item no_bg x" @click="onDelete">
							<div class="key_inner">{{$t('utils.delete')}}</div>
						</div>
					</div>
				</div>
			</div>
		</van-popup>
		<div v-show="setPwd" class="real_name_mask">
			<div class="real_box">
				<div class="tit"></div>
				<p class="tips">
					{{$t('cash.setPwdFirst')}}
				</p>
				<div class="basic_btn" @click="setIniPwd">
					{{$t('cash.setNow')}}
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	import Fetch from "../../utils/fetch";
	import Vue from 'vue';
	import { Progress,Dialog,Field ,
		Popup,
		PasswordInput,
		NumberKeyboard,Switch} from 'vant';
	Vue.use(Progress).use(PasswordInput).use(Popup).use(NumberKeyboard).use(Dialog).use(Field).use(Switch);
	export default {
		name: "itemDetail",
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				data: {},
				auto_close: [],
				show_tz:false,
				number: "",
				checked:true,
				show_ht: false,
				usinfo: [],
				hetongContent: '',
				hetongContent2: '',
				setPwd: false,
				submitType: 1,
				psd_val: '',
				write_psd :false,
				showKeyboard: true,
				Keyboard: [{
					number: 1,
					letter: ""
				}, {
					number: 2,
					letter: "abc"
				}, {
					number: 3,
					letter: "def"
				}, {
					number: 4,
					letter: "ghi"
				}, {
					number: 5,
					letter: "jkl"
				}, {
					number: 6,
					letter: "mno"
				}, {
					number: 7,
					letter: "pqrs"
				}, {
					number: 8,
					letter: "tuc"
				}, {
					number: 9,
					letter: "wxyz"
				}],
				password: ''
			};
		},
		created() {
			this.$parent.footer('item', false);
		},
		mounted() {
			this.start();
			this.getUserInfo();
			this.getHeTong();
		},
		methods: {
			start() {
				Fetch('/index/item_detail', {
					id: this.$router.history.current.params.code
				}).then(res => {
					this.data = res.data;
				})
				// Fetch('/index/item_auto').then((r) => {
				// 	for (var i = 0; i < r.data.ids.length; i++) {
				// 		this.auto_close.push(parseInt(r.data.ids[i]));
				// 	}
				// });
			},
			changeAuto(e)
			{
				console.log(e)
				Fetch("/index/item_auto_c", {
				  pid: this.sku.id,
				  tz_auto: this.checked?1:0
				}).then(r => { 
				}).catch(err=>{
				    this.psd_val = '';
				})
			},
			buy(item){
				if(this.usinfo.intPwd){
					this.setPwd=true;
					return ;
				}
				if (this.auto_close.indexOf(this.data.id) != -1) {
					this.checked = false;
				} else {
					this.checked = true;
				}
				this.show_tz = true;
			},
			getUserInfo(){
				Fetch('/user/info').then(res => {
					this.usinfo = res.data;
					//this.setPwd = res.data.intPwd;
				})
			},
			getHeTong(){
				Fetch('/index/article_detail', {
					id: 15
				}).then(res => {
					this.hetongContent = res.data.content;
				})
			},
			confirm(){
				if(!this.number){
					this.$toast({
						className:"toastName",
						message: this.$t('item.inputAmount'),
					});
					return false;
				}
				this.setIniPwd();
			},
			real_submit(){
				if(!this.password){
					this.$toast({
						className:"toastName",
						message: this.$t('cash.tips'),
					});
					return false;
				}
				Fetch("/index/item_apply", {
				  id: this.data.id,
				  money:this.number,
				  password:this.password
				}).then(r => {
				  this.$router.push("/order");
				}).catch(err=>{
				    this.number = '';
				})
			},
			confirm1(){
				if(!this.number){
					this.$toast({
						className:"toastName",
						message: this.$t('item.inputAmount'),
					});
					return false;
				}
				/*<div class="sw-label">{{$t('utils.pro_name')}}:<span>{{sku[lang]}}</span></div>
				<div class="sw-label">{{$t('utils.tz_name')}}:<span>{{sku[lang]}}</span></div>
				<div class="sw-label">{{$t('utils.pro_company')}}:<span>{{sku[projector]}}</span></div>
				<div class="sw-label">{{$t('utils.db_company')}}:<span>{{sku[db_complany]}}</span></div>
				<div class="sw-label">{{$t('utils.investmentAmount')}}:<span>{{number}} USDT</span></div>
				<div class="sw-label">{{$t('utils.yuji_sy2')}}:<span>{{(sku.rate*number/100).toFixed(5)}} USDT</span></div>*/

				let htmlcon='';
				htmlcon+='<table cellpadding="1" cellspacing="0" bgcolor="#cccccc" width="100%">';
				htmlcon+='<tr>';
				htmlcon+='	<td width="40%" height="26" bgcolor="#ffffff" valign="top">' + this.$t('utils.pro_name')+'</td>';
				htmlcon+='	<td width="60%" bgcolor="#ffffff">' + this.data.title + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="40%" height="26" bgcolor="#ffffff">' + this.$t('utils.tz_name')+'</td>';
				htmlcon+='	<td width="60%" bgcolor="#ffffff">' + this.usinfo.name + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="40%" height="26" bgcolor="#ffffff">' + this.$t('utils.pro_company')+'</td>';
				htmlcon+='	<td width="60%" bgcolor="#ffffff">' + this.$t('utils.pro_company1') + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="40%" height="26" bgcolor="#ffffff">' + this.$t('utils.db_company')+'</td>';
				htmlcon+='	<td width="60%" bgcolor="#ffffff">' + this.data.db_complany + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="40%" height="26" bgcolor="#ffffff">' + this.$t('utils.investmentAmount')+'</td>';
				htmlcon+='	<td width="60%" bgcolor="#ffffff">' + this.number + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="40%" height="26" bgcolor="#ffffff">' + this.$t('utils.yuji_sy2')+'</td>';
				htmlcon+='	<td width="60%" bgcolor="#ffffff">' + (this.data.day*this.number*this.data.rate/100).toFixed(0) + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<table>';

				//章
				let zhangcon='';
				zhangcon+='<table cellpadding="0" cellspacing="0" width="100%">';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">' + this.$t('utils.zhang_jia') + this.data.projector +'</td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">&nbsp;</td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">' + this.$t('utils.zhang_yi') + this.usinfo.name +'</td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">&nbsp;</td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">' + this.$t('utils.zhang_db') + this.data.db_complany +'</td>';
				zhangcon+='</tr>';
				// zhangcon+='<tr>';
				// zhangcon+='	<td valign="top"><img src="' + this.data.db_zhang +'" width="100" height="100" /></td>';
				// zhangcon+='</tr>';
				zhangcon+='<table>';
				this.hetongContent2 = htmlcon + this.hetongContent + zhangcon;
				this.show_ht=true;
			},
			onInput(key) {
				this.psd_val = (this.psd_val + key).slice(0, 6);
				if (this.psd_val.length == 6) {
					this.write_psd = false;
					this.password = this.psd_val;
					if (this.submitType == 1) {
						alert(this.psd_val);
					} else {
						this.setIniPwdSubmit();
					}

				}
			},
			onDelete() {
				this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
			},
			setIniPwdSubmit() {
				this.psd_val = "";
				if(this.usinfo.intPwd){
					Fetch('/user/setIniPwd', {
						password: this.password
					}).then(() => {
						this.getUserInfo();
						this.setPwd = false;
					});
				}
				else{
					this.real_submit();
				}
			},
			setIniPwd() {
				this.submitType = 2;
				this.write_psd = true;
			}
		}
	};
</script>

<style lang="less" scoped>
	/deep/ .van-cell{
		padding: 0px 26px;
	}
	.red_top_bg {
		position: fixed;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
	}

	.back_left {
		background: url(../../views/images/item/back_b.png) no-repeat center center;
	}

	.big_tit {
		left: 40px;
		width: 90%;
		transform: none;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.item_img{
		img{
			width: 100%;
		}
	}
	
	.items_3 {
		.item {
			background: #34167b;
			margin-bottom: 15px;
			border-radius: 10px;
			box-shadow: 0 0 10px rgba(0, 0, 0, .1);
			.item_div1 {
				display: flex;
				align-items: center;
				//border-bottom: 1px solid #ECECEC;
				background-color: #2e126e;
				padding: 10px 15px;
				span{
					font-size: 16px;
					color:#fff;
				}
				img{
					width: 28px;
					height: 28px;
					margin-right: 10px;
				}
				p:nth-child(1) {
					// width: 90%;
					font-weight: bold;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_div2 {
				display: flex;
				justify-content: space-between;
				text-align: center;
				font-size: 14px;
				div {
					width: 33.33%;

					p {
						padding: 5px 0;
					}
				}

				.item_rate {
					p:nth-child(1) {
						font-weight: bold;
						color: #FF0000;

					}

					p:nth-child(2) {
						color: #999;
					}
				}

				.item_day {
					p:nth-child(1) {
						font-weight: bold;
					}

					p:nth-child(2) {
						color: #999;
					}
				}

				.item_min {
					p:nth-child(1) {
						font-weight: bold;

					}

					p:nth-child(2) {
						color: #999;
					}
				}
			}

			.item_div3 {
				color: #999;
				padding: 5px 10px;
			}
			.flex_bd{
				flex: 1;
				margin: 0;
			}

			.item_div4 {
				padding: 0 15px;
				//margin-top: 15px;
				.item-per{
					font-size: 16px;
					color: #ffffff;
					margin-bottom: 10px;
				}
				.flex_bd{
					flex: 1;
				}
			}
			.item_btn {
				left: 15px;
				right: 15px;
				position: absolute;
				bottom: 15px;
				button {
					width: 100%;
					color: #FFFFFF;
					padding: 12px 5px;
					border-radius: 5px;
					border: 1px solid #e93827;
					background: #e93827;
				}
				.item_btn_over{
					color: #999;
					border: 1px solid #999;
				}
			}
		}
		.item_content{
			background: #34167b;
			box-shadow: 0 0 10px rgba(0, 0, 0, .1);
			border-radius: 10px;
			padding: 10px;
			line-height: 20px;
			color:#ffffff;
		}
	}
	.item-main{
		padding: 15px;
		margin-top: 44px;
	}
	.item_img{
		margin-bottom: 15px;
		font-size: 0;
	}
	.item-progress{
		display: flex;
		align-items: center;
		//background-color: #e9e9e9;
		padding:2px 5px;
		border-radius: 40px;
		/deep/ .van-progress__pivot{
			display: none;
		}
		.item-pv{
			display: block;
			line-height: 1;
			color: #e82637;
			margin-left: 10px;
		}
	}
	.item-body{
		padding: 0 0 15px 0;
		.item_desr{
			display: flex;
			justify-content: space-between;
			padding:10px;
			.item_desr_left{
				color:#ffffff;
				background-color: #5812f8;
				padding:5px 10px;
			}
			.item_desr_right{
				color:#ffffff;
				//background-color: #2e126e;
				span{color: #999;}
			}
		}
	}
	.show-body{
		padding: 20px;
		font-size: 14px;
		.sw-label{
			margin-bottom: 10px;
		}
		.sw-bar{
			display: flex;
			align-items: center;
			background-color: #f5f5f5;
			padding: 10px;
			border-radius: 4px;
			.flex_bd{
				color: #999999;
			}
		}
	}
	.sw-grid{
		display: flex;
		align-items: flex-end;
		margin-top: 20px;
		.sw-row:first-child{
			margin-bottom:20px;
		}
		.sw-row > div:first-child{
			margin-bottom: 10px;
		}
		
		.sw-info{
			color: #999;
		}
		.sw-val.text-green{
			font-size: 16px;
		}
	}
	.sw-right{
		text-align: center;
		.sw-lg{
			font-size: 24px;
			margin-bottom: 10px;
		}
	}
	
	
	.flex_bd{
		flex: 1;
	}
	.popup{
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 80vh;
		padding: 26px 24px;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}
	
	.basic_btn {
		width: 213px;
		height: 35px;
		line-height: 35px;
		font-size: 12px;
		margin: 0 auto;
	}
	.psw_tips{
		font-size: 12px;
		color: #666666;
		text-align: center;
		margin-bottom: 20px;
	}
	
	.psw_content{
		padding: 22px 15px 38px;
		
		.psw_complete{
			margin: 20px auto 0 auto;
		}
		
		.van-password-input{
			margin: 0;
		}
	}
	[type="number"]{
		appearance:none;
		-webkit-appearance:none;
	}
	.van-password-input .van-password-input__security{
		height: 46px;
		justify-content: space-between;
	}
	
	.van-password-input .van-password-input__security::after{
		display: none;
	}
	
	.van-password-input__security li{
		width: 46px;
		border: 1px solid #d5d5d5;
		flex: unset;
		background-color: #f5f5f5;
	}

	.van-password-input .van-password-input__security::after {
		border-radius: 0;
	}

	.keybord_box {
		background-color: #c3c7cc;
		padding: 9px 6px 3px;

		.keybord {
			margin: 24px auto 0 atuo;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			text-align: center;

			.key_item {
				width: 32.33%;
				height: 50px;
				margin-bottom: 6px;
				background: rgba(255, 255, 255, 1);
				border-radius: 3px;
				padding: 6px;
				box-shadow:  0 0 4px rgba(68, 68, 68, .35);

				.key_inner {
					font-size: 25px;
					font-weight: bold;
				}

				.key_letter {
					font-size: 12px;
					color: #212121;
					text-transform: uppercase;
				}
			}

			.no_bg {
				.key_inner {
					font-size: 22px;
					line-height: 38px;
				}
			}

			.x {
				color: #e82637;
			}
		}
	}
</style>
